{
  "name": "web",
  "private": true,
  "version": "2.36.3",
  "type": "module",
  "packageManager": "yarn@1.22.22",
  "scripts": {
    "dev": "vite",
    "build": "vite build",
    "lint": "eslint . --fix",
    "type-check": "vue-tsc --build",
    "preview": "vite preview"
  },
  "dependencies": {
    "@iconify-json/lucide": "^1.2.143",
    "@nuxt/ui": "^4.11.3",
    "@sentry/vue": "^11.6.0",
    "@vueuse/core": "^15.0.0",
    "dayjs": "^1.11.23",
    "pinia": "^4.0.3",
    "query-string": "^9.5.1",
    "tailwindcss": "^4.3.3",
    "vue": "^3.5.42",
    "vue-i18n": "^11",
    "vue-router": "^4",
    "zod": "^4.6.6"
  },
  "devDependencies": {
    "@types/node": "^24.13.3",
    "@vitejs/plugin-vue": "^6.0.8",
    "@vue/eslint-config-typescript": "^14.9.0",
    "@vue/tsconfig": "^0.9.1",
    "eslint": "^10.12.0",
    "eslint-plugin-vue": "^10.11.1",
    "typescript": "~6.0.2",
    "vite": "^8.3.0",
    "vue-tsc": "^3.3.13"
  }
}
